<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        @if (!orderProductShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="orderProducts" formControlName="orderProductId" optionLabel="name"
              optionValue="orderProductId" placeholder="Order Product" [filter]="true" filterBy="name" [showClear]="false"></p-dropdown>
              <label for="orderProductId">Order Product</label>
              @for (validation of validationMessages.orderProductId; track validation) {
                <span>
                  @if (form1.get('orderProductId').hasError(validation.type) && (form1.get('orderProductId').dirty || form1.get('orderProductId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }
        @if (orderProductShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="orderProducts" formControlName="orderProductId" optionLabel="name"
              optionValue="orderProductId" placeholder="Order Product" readonly="true" [filter]="true" filterBy="name" [showClear]="false"></p-dropdown>
              <label for="orderProductId">Order Product</label>
              @for (validation of validationMessages.orderProductId; track validation) {
                <span>
                  @if (form1.get('orderProductId').hasError(validation.type) && (form1.get('orderProductId').dirty || form1.get('orderProductId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        @if (!orderProductShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
              optionValue="shortTermRentalId" placeholder="Properties" [filter]="true" filterBy="propertyCode" [showClear]="false"></p-dropdown>
              <label for="shortTermRentalId">Properties</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        @if (orderProductShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
              optionValue="shortTermRentalId" placeholder="Properties" [filter]="true" filterBy="propertyCode" [showClear]="false" readonly="true"></p-dropdown>
              <label for="shortTermRentalId">Properties</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

			<div pTooltip="Select 'Mandatory', if its required while booking
			Select 'Optional', if its not required while booking
			Selection is required for new order product workflow" class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="feeTypes" formControlName="feeType" optionLabel="name"
            optionValue="value" placeholder="Fee Type"></p-dropdown>
            <label for="feeType">Fee Type</label>
            @for (validation of validationMessages.feeType; track validation) {
              <span>
                @if (form1.get('feeType').hasError(validation.type) && (form1.get('feeType').dirty || form1.get('feeType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

			<div pTooltip="Its added the quantity in guest invoice for booking
			Ex. 
			Per reservation: add qty 1
			Per Night: add qty as a number of booking night" class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="feeFrequencies" formControlName="feeFrequency" optionLabel="name"
            optionValue="value" placeholder="Fee Frequency"></p-dropdown>
            <label for="feeFrequency">Fee Frequency</label>
            @for (validation of validationMessages.feeFrequency; track validation) {
              <span>
                @if (form1.get('feeFrequency').hasError(validation.type) && (form1.get('feeFrequency').dirty || form1.get('feeFrequency').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="valuePCT" id="valuePCT" type="text" pInputText>
          <label for="valuePCT">Percentage</label>
          <span *ngFor="let validation of validationMessages.valuePCT">
            <small class="p-invalid"
              *ngIf="form1.get('valuePCT').hasError(validation.type) && (form1.get('valuePCT').dirty || form1.get('valuePCT').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->
			<div pTooltip="Please add percentage value in decimal format
			Ex: If percentage value is '4.712%' then enter '0.04712' in percentage input box" class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber formControlName="valuePCT" inputId="valuePCT"
            [minFractionDigits]="2" [maxFractionDigits]="5" [min]="0" [max]="1" [step]="0.00001">
          </p-inputNumber>
          <label for="valuePCT">Value Pct</label>
          <!-- <div fxFlex="calc(100% - 30px)">
          <mat-label>Value Pct : <b>{{valuePCT.value*100 | number : '1.0-2'}}%</b></mat-label>
          <div>
            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('valuePCT')">
              <i class="pi pi-minus"></i>
            </button>
            <mat-slider fxFlex #valuePCT formControlName="valuePCT" min="0" max="1" step=".01"
              pTooltip="Range: 0 to 100 as decimal. Income high values in percentage"
              tooltipPosition="bottom">
            </mat-slider>
            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('valuePCT')">
              <i class="pi pi-plus"></i>
            </button>
          </div>
          <span *ngIf="invalidHighOccupancyPct">
            <small class="p-invalid">Target High Pct can not be zero or lower than target or low pct.</small>
          </span>
        </div> -->
        @for (validation of validationMessages.valuePCT; track validation) {
          <span>
            @if (form1.get('valuePCT').hasError(validation.type) && (form1.get('valuePCT').dirty || form1.get('valuePCT').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <!-- <div class="col-lg-6">
    <span class="p-float-label required-field w-100 mb-3">
      <p-inputMask formControlName="valuePCT" id="valuePCT"
      mask="9.9?9?9?9"></p-inputMask>
      <label for="valuePCT">Value Pct</label>
      <div fxFlex="calc(100% - 30px)">
        <mat-label>Value Pct : <b>{{valuePCT.value*100 | number : '1.0-2'}}%</b></mat-label>
        <div>
          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('valuePCT')">
            <i class="pi pi-minus"></i>
          </button>
          <mat-slider fxFlex #valuePCT formControlName="valuePCT" min="0" max="1" step=".01"
            pTooltip="Range: 0 to 100 as decimal. Income high values in percentage"
            tooltipPosition="bottom">
          </mat-slider>
          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('valuePCT')">
            <i class="pi pi-plus"></i>
          </button>
        </div>
        <span *ngIf="invalidHighOccupancyPct">
          <small class="p-invalid">Target High Pct can not be zero or lower than target or low pct.</small>
        </span>
      </div>
      <span *ngFor="let validation of validationMessages.valuePCT">
        <small class="p-invalid"
          *ngIf="form1.get('valuePCT').hasError(validation.type) && (form1.get('valuePCT').dirty || form1.get('valuePCT').touched)">{{validation.message}}
        </small>
      </span>
    </span>
  </div> -->

  <div pTooltip="Legacy column, not in use, not required to setup new order product tax work-flow" class="col-lg-6">
    <span class="p-float-label required-field w-100 mb-3">
      <p-inputNumber formControlName="valueAMT" [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
      </p-inputNumber>
      <label for="valueAMT">Value Amount</label>
      @for (validation of validationMessages.valueAMT; track validation) {
        <span>
          @if (form1.get('valueAMT').hasError(validation.type) && (form1.get('valueAMT').dirty || form1.get('valueAMT').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>



  <!-- <div class="col-lg-6">
  <mat-label>Value Percentage : <b>{{valuePCT.value*100}}%</b></mat-label>
  <div>
    <mat-slider fxFlex #valuePCT formControlName="valuePCT"
      min="-1" max="1" step=".01"
      pTooltip="Range: -1 to 1 as decimal.  Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly.   Will not go lower than the the Min Nightly Rate $ setting below."
      tooltipPosition="bottom">
    </mat-slider>
  </div>
</div> -->

<div pTooltip="Its detail description of the product. not going to show to guest invoice. its used for KBM team " class="col-lg-12">
  <span class="p-float-label w-100 mb-3">
    <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
    <label for="description">Description</label>
    @for (validation of validationMessages.opsNotes; track validation) {
      <span>
        @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('description').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>


<!-- <div class="col-lg-12 mb-3">
<h6 for="active">Active</h6>
<div class="flex align-items-center">
  <p-checkbox [formControl]="form1.controls['active']" inputId="active" [binary]="true"></p-checkbox>
  <span class="test-nm">Active?</span>
</div>
<span *ngFor="let validation of validationMessages.active">
  <small class="p-invalid"
    *ngIf="form1.get('active').hasError(validation.type) && (form1.get('active').dirty || form1.get('active').touched)">{{validation.message}}
  </small>
</span>
</div> -->

<div pTooltip="Amount of this order product added into nighlty rate while reservation is created." class="col-lg-12 mb-3">
  <h6 for="addToRate">Add To Rate</h6>
  <div class="flex align-items-center">
    <p-checkbox [formControl]="form1.controls['addToRate']" inputId="addToRate" [binary]="true"></p-checkbox>
    <span class="test-nm">Add To Rate?</span>
  </div>
  @for (validation of validationMessages.addToRate; track validation) {
    <span>
      @if (form1.get('addToRate').hasError(validation.type) && (form1.get('addToRate').dirty || form1.get('addToRate').touched)) {
        <small class="p-invalid"
          >{{validation.message}}
        </small>
      }
    </span>
  }
</div>

<!-- Date: 2026-04-09 Author: Alkesh PCT addToRate config — shown only when valuePCT is configured -->
@if (form1.get('valuePCT')?.value) {
  <div pTooltip="Select the base amount the PCT percentage is applied against to calculate the fee" class="col-lg-12 mb-3">
    <span class="p-float-label w-100">
      <p-dropdown class="w-100" [options]="valuePCTAppliedToOptions" formControlName="valuePCTAppliedTo"
        optionLabel="name" optionValue="value" inputId="valuePCTAppliedTo">
      </p-dropdown>
      <label for="valuePCTAppliedTo">PCT Applied To</label>
    </span>
  </div>

  <div pTooltip="When enabled, PCT fee amount is included in the per-night LOS rate calculation for YieldMax sync" class="col-lg-12 mb-3">
    <h6 for="isAddPCTIntoLOS">Include PCT in LOS Rate</h6>
    <div class="flex align-items-center">
      <p-checkbox [formControl]="form1.controls['isAddPCTIntoLOS']" inputId="isAddPCTIntoLOS" [binary]="true"></p-checkbox>
      <span class="test-nm">Include PCT in LOS Rate?</span>
    </div>
  </div>
}

<div pTooltip="Its used when order product available based on reservation rules: Ex. free rental cars available only if reservation at least for 6 nights" class="col-lg-6 mb-3">
  <h6 for="useBookingRule">Use Booking Rule</h6>
  <div class="flex align-items-center">
    <p-checkbox [formControl]="form1.controls['useBookingRule']" inputId="useBookingRule" [binary]="true"></p-checkbox>
    <span class="test-nm">Use Booking Rule?</span>
  </div>
  @for (validation of validationMessages.useBookingRule; track validation) {
    <span>
      @if (form1.get('useBookingRule').hasError(validation.type) && (form1.get('useBookingRule').dirty || form1.get('useBookingRule').touched)) {
        <small class="p-invalid"
          >{{validation.message}}
        </small>
      }
    </span>
  }
</div>

<div class="col-lg-12 mb-3">
  <h6 for="addToRate">Show To Customer as a free</h6>
  <div class="flex align-items-center">
    <p-checkbox [formControl]="form1.controls['showToCustomer']" inputId="showToCustomer" [binary]="true"></p-checkbox>
    <span class="test-nm">Show To Customer as a free?</span>
  </div>
  @for (validation of validationMessages.showToCustomer; track validation) {
    <span>
      @if (form1.get('showToCustomer').hasError(validation.type) && (form1.get('showToCustomer').dirty || form1.get('showToCustomer').touched)) {
        <small class="p-invalid"
          >{{validation.message}}
        </small>
      }
    </span>
  }
</div>

<div pTooltip="Order product only available if reservation is created for at least for this number of night. this rule only applied when 'Use Booking Rule' flag is set" class="col-lg-12">
  <span class="p-float-label w-100 mb-3">
    <p-dropdown class="w-100" [options]="applyStaysOfNtsList" formControlName="applyStaysOfAtLeastNts" optionLabel="name"
    optionValue="value" placeholder="Apply Stays Of At Least Nts"></p-dropdown>
    <label for="applyStaysOfAtLeastNts">Apply Stays Of At Least Nts</label>
    @for (validation of validationMessages.applyStaysOfAtLeastNts; track validation) {
      <span>
        @if (form1.get('applyStaysOfAtLeastNts').hasError(validation.type) && (form1.get('applyStaysOfAtLeastNts').dirty || form1.get('applyStaysOfAtLeastNts').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>

<div pTooltip="Order product only available if reservation is created for less than of this number of night. this rule only applied when 'Use Booking Rule' flag is set" class="col-lg-12">
  <span class="p-float-label w-100 mb-3">
    <p-dropdown class="w-100" [options]="applyStaysOfNtsList" formControlName="applyStaysOfLessThanNts" optionLabel="name"
    optionValue="value" placeholder="Apply Stays Of Less Than Nts"></p-dropdown>
    <label for="applyStaysOfLessThanNts">Apply Stays Of Less Than Nts</label>
    @for (validation of validationMessages.applyStaysOfLessThanNts; track validation) {
      <span>
        @if (form1.get('applyStaysOfLessThanNts').hasError(validation.type) && (form1.get('applyStaysOfLessThanNts').dirty || form1.get('applyStaysOfLessThanNts').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>


</div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (orderProductShortTermRentalFlag) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!orderProductShortTermRentalFlag) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
          }

          @if (orderProductShortTermRentalFlag) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>